import { render, staticRenderFns } from "./MenuFooterNav.vue?vue&type=template&id=2957111d&scoped=true&"
import script from "./MenuFooterNav.vue?vue&type=script&lang=js&"
export * from "./MenuFooterNav.vue?vue&type=script&lang=js&"
import style0 from "./MenuFooterNav.vue?vue&type=style&index=0&id=2957111d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957111d",
  null
  
)

export default component.exports